<div class="flex items-center justify-center dialog-header ">
  {{type}} Campus

  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>

</div>

<div class="dialog-content">
  <form [formGroup]="campusForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

    <!-- Name -->
    <div class="flex flex-col">
      <label for="name" class="mb-2 font-semibold ">Name *</label>
      <input pInputText id="name" formControlName="name"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="campusForm.get('name')?.invalid && (campusForm.get('name')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Name is required.
      </div>
    </div>

    <!-- Status -->
    <div class="flex flex-col">
      <label for="status" class="mb-2 font-semibold ">Status *</label>
      <p-dropdown id="status" [options]="statusOptions" formControlName="status" placeholder="Select a status"
        class="w-full" />
      <div *ngIf="campusForm.get('status')?.invalid && (campusForm.get('status')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Status is required.
      </div>
    </div>

    <!-- Code -->
    <div class="flex flex-col">
      <label for="code" class="mb-2 font-semibold ">Code *</label>
      <input pInputText id="code" formControlName="code"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="campusForm.get('code')?.invalid && (campusForm.get('code')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Code is required.
      </div>
    </div>

    <!-- Address -->
    <div class="flex flex-col">
      <label for="address" class="mb-2 font-semibold ">Address</label>
      <input pInputText id="address" formControlName="address"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <!-- City -->
    <div class="flex flex-col">
      <label for="city" class="mb-2 font-semibold ">City *</label>
      <input pInputText id="city" formControlName="city"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="campusForm.get('city')?.invalid && (campusForm.get('city')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        City is required.
      </div>

    </div>

    <!-- State -->
    <div class="flex flex-col">
      <label for="state" class="mb-2 font-semibold ">State *</label>
      <input pInputText id="state" formControlName="state"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />

      <div *ngIf="campusForm.get('state')?.invalid && (campusForm.get('state')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        State is required.
      </div>
    </div>

    <!-- Country -->
    <div class="flex flex-col">
      <label for="country" class="mb-2 font-semibold ">Country *</label>
      <input pInputText id="country" formControlName="country"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="campusForm.get('country')?.invalid && (campusForm.get('country')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Country is required.
      </div>
    </div>

    <!-- Postal Code -->
    <div class="flex flex-col">
      <label for="postal_code" class="mb-2 font-semibold ">Postal Code</label>
      <input pInputText type="number" id="postal_code" formControlName="postal_code"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <!-- Contact Number -->
    <div class="flex flex-col">
      <label for="contact_number" class="mb-2 font-semibold ">Contact Number</label>
      <input pInputText id="contact_number" formControlName="contact_number"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <!-- Email -->
    <div class="flex flex-col">
      <label for="email" class="mb-2 font-semibold ">Email *</label>
      <input pInputText id="email" formControlName="email"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="campusForm.get('email')?.errors?.['email'] && (campusForm.get('email')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">
        Invalid email format.
      </div>
    </div>

    <!-- Website -->
    <div class="flex flex-col">
      <label for="website" class="mb-2 font-semibold ">Website</label>
      <input pInputText id="website" formControlName="website"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <!-- Campus Type -->
    <div class="flex flex-col">
      <label for="campus_type" class="mb-2 font-semibold ">Campus Type</label>
      <input pInputText id="campus_type" formControlName="campus_type"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <!-- Submit Button (full width) -->
    <div class="col-span-2 flex justify-end mt-6">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
        [disabled]="campusForm.invalid || isLoading"></p-button>
    </div>

  </form>

</div>